<template>
  <div>
    <div>
      <div class="userInfor">
        <span>当前从业信息</span>
        <div class="btn">
          <el-button size="small" type="primary" style="margin-top: 12px" @click="prev">上一步</el-button>
          <el-button size="small" type="success" style="margin-top: 12px" @click="save('ruleFormAdd')">保存</el-button>
          <el-button size="small" type="warning" style="margin-top: 12px" @click="next('ruleFormAdd')">下一步</el-button>

        </div>
      </div>

      <!-- 从业信息 -->
      <div class="infomation">
        <el-form ref="ruleFormAdd" :model="ruleFormAdd" :rules="rules" label-width="150px" style="padding: 0 30px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位名称：" prop="unitName" :label-width="formLabelWidth">
                <el-input v-model="ruleFormAdd.unitName" placeholder="请输入单位名称" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码：" prop="creCode" :label-width="formLabelWidth">
                <el-input v-model="ruleFormAdd.creCode" placeholder="请输入统一社会信用代码" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="主技术领域：" prop="industry" :label-width="formLabelWidth">
                <el-select v-model="ruleFormAdd.industry" placeholder="请选择">
                  <el-option v-for="(item, index) in industryList" :key="index" :label="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="secondaryIndustry" :label-width="formLabelWidth">
                <span slot="label" style="display: inline-block">
                  次技术领域
                  <el-tooltip effect="dark" content="次选技术领域须与主选技术领域有高度相关性" placement="top-start" style="margin: 0 2px">
                    <i class="el-icon-question" /> </el-tooltip>：
                </span>
                <el-select v-model="ruleFormAdd.secondaryIndustry" placeholder="请选择" clearable>
                  <el-option v-for="(item, index) in industryList" :key="index" :label="item.value"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="工作部门：" prop="depart" :label-width="formLabelWidth">
                <el-input v-model="ruleFormAdd.depart" placeholder="请输入工作部门" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"><el-form-item label="任职岗位：" prop="post" :label-width="formLabelWidth">
                <el-input v-model="ruleFormAdd.post" placeholder="请输入任职岗位" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="12">
              <el-form-item label="工作开始时间：" prop="workStartTime" :label-width="formLabelWidth"
                style="text-align: center">
                <el-date-picker v-model="ruleFormAdd.workStartTime" type="date" style="width: 100%"
                  value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工作结束时间：" :label-width="formLabelWidth" style="text-align: center">
                <el-date-picker v-model="ruleFormAdd.workEndTime" type="date" style="width: 100%"
                  value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
                </el-date-picker>
                <!-- <p style="color: rgb(20, 127, 238); font-size: 12px">
                  目前一直在该单位工作，工作结束时间请选择当前日期
                </p> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="24"><el-form-item label="工作说明：" prop="workMemo" :label-width="formLabelWidth">
                <el-input rows="4" type="textarea" maxlength="100" placeholder="请输入"
                  v-model="ruleFormAdd.workMemo"></el-input> </el-form-item></el-col>
          </el-row>
          <el-row :gutter="22">
            <el-col :span="20"><el-form-item label="附件：" :label-width="formLabelWidth">
                <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemove(file, 'D')"
                  :multiple="false" :limit="1" accept=".png,.jpg,.jpeg,.bmp,.pdf" :on-exceed="handleExceed"
                  :before-upload="beforeAvatarUpload" :file-list="fileListWork"
                  :http-request="(file) => submitUpload(file, 'D')" :on-preview="(file) => handlePreview(file)">
                  <el-button size="small" type="primary" plain>
                    <i class="el-icon-upload2"></i> 点击上传</el-button>
                  <span style="
                      color: rgb(20, 127, 238);
                      font-size: 12px;
                      margin-left: 5px;
                    ">
                    上传工作说明或其他证明材料</span>
                  <div slot="tip" class="el-upload__tip">
                    文件扩展名：pdf、jpg、jpeg、png、bmp
                  </div>
                </el-upload>
              </el-form-item></el-col>
          </el-row>
          <!-- <el-row :gutter="22">
            <el-col :span="20"><el-form-item label="社保证明：" :label-width="formLabelWidth">
                <el-upload class="upload-demo" action="/index/upload" :on-remove="(file) => handleRemove(file, 2)"
                  :multiple="false" :limit="1" accept=".png,.jpg,.jpeg,.bmp,.pdf" :on-exceed="handleExceed"
                  :before-upload="beforeAvatarUpload" :file-list="fileList" :on-preview="(file) => handlePreview(file)"
                  :http-request="(file) => submitUpload(file, 2)">
                  <el-button size="small" type="primary" plain>
                    <i class="el-icon-upload2"></i> 点击上传</el-button>
                  <span style="
                      color: rgb(20, 127, 238);
                      font-size: 12px;
                      margin-left: 5px;
                    ">
                    上传近6个月的社保证明材料</span>
                  <div slot="tip" class="el-upload__tip">
                    文件扩展名：pdf、jpg、jpeg、png、bmp
                  </div>
                </el-upload>
              </el-form-item></el-col>
          </el-row> -->

        </el-form>
      </div>
    </div>

    <div class="userInfor">
      <span>先前从业经历
      </span>
      <div class="btn">
        <el-button size="small" type="primary" style="margin-top: 12px" @click="addPerson('1')">增加从业经历</el-button>
      </div>
    </div>

    <!-- 增加从业经历 -->
    <div class="infomation">
      <span></span>
      <div class="infomation_item" v-for="(item, index) in dataFrom" :key="index">
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <h2>{{ item.unitName }}</h2>
          <div>
            <el-button type="text" @click="addPerson('2', item)">编辑</el-button>
            <el-button type="text" @click="del(item, index)">删除</el-button>
          </div>
        </div>

        <p>
          <span>{{ item.creCode }}</span>
          <span>{{ item.depart }}</span>
          <!-- <span>主技术领域：{{ item.industry }}</span>
          <span v-show="item.secondaryIndustry">次技术领域：{{ item.secondaryIndustry }}</span> -->
          <span>{{ item.post }}</span>
          <span>{{ formatTimes(item.workStartTime) }} 至
            {{ formatTimes(item.workEndTime) }}</span>
        </p>
        <p>{{ item.workMemo }}</p>
      </div>
    </div>
    <el-dialog title="增加从业经历" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="60%">
      <el-form ref="ruleForm" :rules="rulesdata" :model="ruleForm" style="padding: 0 30px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位名称：" prop="unitName" :label-width="formLabelWidth">
              <el-input v-model="ruleForm.unitName" placeholder="请输入单位名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：" prop="creCode" :label-width="formLabelWidth">
              <el-input v-model="ruleForm.creCode" placeholder="请输入统一社会信用代码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主技术领域：" prop="industry" :label-width="formLabelWidth">
              <el-select v-model="ruleForm.industry" placeholder="请选择" :popper-append-to-body="false">
                <el-option v-for="(item, index) in industryList" :key="index" :label="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="secondaryIndustry" :label-width="formLabelWidth">
              <span slot="label" style="display: inline-block">次技术领域
                <el-tooltip effect="dark" content="次选技术领域须与主选技术领域有高度相关性" placement="top-start" style="margin: 0 2px">
                  <i class="el-icon-question" /> </el-tooltip>：
              </span>
              <el-select v-model="ruleForm.secondaryIndustry" placeholder="请选择" :popper-append-to-body="false"
                clearable>
                <el-option v-for="(item, index) in industryList" :key="index" :label="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="工作部门：" prop="depart" :label-width="formLabelWidth">
              <el-input v-model="ruleForm.depart" placeholder="请输入工作部门"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="任职岗位：" prop="post" :label-width="formLabelWidth">
              <el-input v-model="ruleForm.post" placeholder="请输入任职岗位"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="工作开始时间：" prop="workStartTime" style="text-align: center" :label-width="formLabelWidth">
              <!-- <el-date-picker
                v-model="ruleForm.workTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="timeout"
              >
              </el-date-picker> -->

              <el-date-picker v-model="ruleForm.workStartTime" type="date" style="width: 100%" value-format="yyyy-MM-dd"
                :picker-options="pickerOptions" placeholder="选择日期">
              </el-date-picker>
              <!-- <span style="color: rgb(20, 127, 238); font-size: 12px"
                >目前一直在该单位工作，工作结束时间请选择当前日期</span
              > -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作结束时间：" prop="workEndTime" style="text-align: center" :label-width="formLabelWidth">
              <el-date-picker v-model="ruleForm.workEndTime" type="date" style="width: 100%" value-format="yyyy-MM-dd"
                :picker-options="pickerOptions" placeholder="选择日期">
              </el-date-picker>
              <!-- <span style="color: rgb(20, 127, 238); font-size: 12px">目前一直在该单位工作，工作结束时间请选择当前日期</span> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="24"><el-form-item label="工作说明：" prop="workMemo" :label-width="formLabelWidth">
              <el-input rows="4" type="textarea" maxlength="100" placeholder="请输入"
                v-model="ruleForm.workMemo"></el-input> </el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="nosubmit('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <!-- <img width="100%" :src="dialogImageUrl" alt="" /> -->
      <img width="100%" :src="lookFile" alt="" v-if="lookFile" />
      <iframe v-if="pdfLook" :src="pdfLook" toolbar="0" style="
                      border: none;
                      width: 100%;
                      min-height:600px;
                      margin: 0 auto;
                    "></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { getPicture } from "@/api/getinform/getinform.js";
import { getDictInfoNew, unitDetail, userInfo, delectFile, unitDel } from "@/api/api.js";

export default {
  name: "",
  components: {},
  props: {
    // regions:{
    //   type: String || Number, //指定值类型
    //   required: true, //是否为必传项
    // }
    // infoMation: Object,
    activeNum: Number,
    changeId: String,
    idsession: String
  },
  data() {
    let checkUserId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入统一社会信用代码"));
      } else {
        const reg = /^[A-Za-z0-9]{18}$/;
        // const regs = /^[A-Za-z0-9]{15}$/;
        if (!reg.test(value)) {
          const msg = rule.msg
            ? rule.msg
            : "统一社会信用代码长度18位数字、字母";
          return callback(new Error(msg));
        } else {
          return callback();
        }
      }
    };
    return {
      industryList: [],
      ruleFormAdd: {
        unitName: "", //单位名称
        creCode: "", //统一识别代码
        // industry: "", //行业分类
        // secondaryIndustry: "",
        depart: "", //部门
        post: "", //职务
        workMemo: "", //工作说明
        isNowUnit: "", //是否当前从事单位 0是 ,1之前从事单位
        userId: "",
        workStartTime: "",
        workEndTime: "",
        // socialSecurityFileId: "", //附件
        descriptionOfWorkFileId: "", //附件
      },
      active: Number(sessionStorage.getItem("operStep")),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now(); // 选当前时间之后的时间
        },
      },
      fileList: [],
      ruleForm: {
        unitName: "", //单位部门
        creCode: "", //统一信用代码
        // industry: "", //技术领域
        // secondaryIndustry: "", //技术领域
        industryName: "",
        depart: "", //从事部门
        post: "", //任职岗位
        workStartTime: "", //工作时间
        workEndTime: "", //工作时间
        workMemo: "", //工作说明
        isNowUnit: "1", //是否当前从事单位 0是 ,1之前从事单位
        userId: "",
        //
        // workTime: null,
      },
      annexFile: {},
      rules: {
        // unitName: [
        //   { required: true, message: "请输入单位名称", trigger: "blur" },
        //   {
        //     max: 30,
        //     message: "长度在 1 到 30 个字符",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        creCode: [
          // {
          //   required: true,
          //   message: "请输入统一社会信用代码",
          //   trigger: "change",
          // },
          { validator: checkUserId, trigger: ["blur", "change"] },
        ],
        // industry: [
        //   { required: true, message: "请选择主技术领域", trigger: "change" },
        // ],
        // depart: [
        //   { required: true, message: "请输入工作部门", trigger: "blur" },
        //   {
        //     max: 30,
        //     message: "长度在 1 到 30 个字符",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // post: [
        //   { required: true, message: "请输入任职岗位", trigger: "blur" },
        //   {
        //     max: 30,
        //     message: "长度在 1 到 30 个字符",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // workStartTime: [
        //   { required: true, message: "请选择工作时间", trigger: "blur" },
        // ],
        // workEndTime: [
        //   { required: true, message: "请选择工作时间", trigger: "blur" },
        // ],
      },
      rulesdata: {
        unitName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
          {
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: ["blur", "change"],
          },
        ],
        creCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
          { validator: checkUserId, trigger: ["blur", "change"] },
        ],
        // industry: [
        //   { required: true, message: "请选择主技术领域", trigger: "change" },
        // ],
        // secondaryIndustry:[
        //  { required: true, message: "请选择次技术领域", trigger: "blur" },
        // ],
        depart: [
          { required: true, message: "请输入工作部门", trigger: "blur" },
          {
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: ["blur", "change"],
          },
        ],
        post: [
          { required: true, message: "请输入任职岗位", trigger: "blur" },
          {
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: ["blur", "change"],
          },
        ],
        workStartTime: [
          { required: true, message: "请选择工作时间", trigger: "blur" },
        ],
        workEndTime: [
          { required: true, message: "请选择工作时间", trigger: "blur" },
        ],
        workMemo: [
          { required: true, message: "请填写工作说明", trigger: "blur" },
        ],
      },
      formLabelWidth: "150px",
      dialogFormVisible: false,
      id: 0,
      status: "",
      dataFrom: [],
      workTimeOld: "",
      istype: "1",
      fileListWork: [],
      isEdit: "",
      infoMation: {},
      userInfoid: this.$route.query.userInfos,
      dialogVisible: false,
      pdfLook: "",
      lookFile: "",
    };
  },
  computed: {
    formIsFilled() {
      return Object.values(this.ruleFormAdd).some((value) => value);
    },
    formIsFilleds() {
      return Object.values(this.ruleFormAdd).every((value) => value);
    },
  },
  watch: {
    "$store.state.region"(newValue) {
      // console.log(newValue, "region");
      this.istype = newValue;
    },
    activeNum(val) {
      if (val == 2) {
        if (this.userInfoid == null) {
          this.userInfoid = sessionStorage.getItem('userInfoid')
        }
        if (this.userInfoid) {
          this.getDetail();
        }
      }
    },
    // idsession(val){
    //   // console.log(val,this.activeNum)
    //   if(val && this.activeNum == 2){
    //     this.userInfoid = val
    //     this.getDetail()
    //   }
    // }

  },
  created() {
    // if (this.userInfoid) {
    //   this.getDetail();
    // }
    this.getIndustrys();
    // console.log(this.infoMation,'this.infoMation')
  },
  mounted() {
    if (this.userInfoid) {
      this.getDetail();
    }
    // getDictInfoNew("ZZGZSJ").then((res) => {
    //   // console.log(res);
    //   this.workTimeOld = res.data[0].value;
    // });

  },
  methods: {
    getInfo() {
      if (sessionStorage.getItem("user")) {
        let user = JSON.parse(sessionStorage.getItem("user"));
        userInfo({ id: user.id }).then((res) => {
          this.infoMation = res.data;
          let obj = this.infoMation.unitInfo;
          this.ruleFormAdd.unitName = obj.unit_name; //单位名称
          this.ruleFormAdd.creCode = obj.creCode; //统一识别代码
          // this.ruleFormAdd.industry = obj.industry; //行业分类
          // this.ruleFormAdd.secondaryIndustry = obj.secondaryIndustry;
          this.ruleFormAdd.depart = obj.depart; //部门
          this.ruleFormAdd.post = obj.post; //职务
          this.ruleFormAdd.workMemo = obj.workMemo; //工作说明
          this.ruleFormAdd.workStartTime = obj.workStartTime;
          this.ruleFormAdd.workEndTime = obj.workEndTime;
        });
      }
    },
    getDetail() {
      if (this.userInfoid == null) {
        this.userInfoid = sessionStorage.getItem('userInfoid')
      }
      unitDetail(this.$qs.stringify({ id: this.userInfoid })).then((res) => {
        if (res.code == "1000") {
          if (res.data && res.data.length) {
            this.isEdit = "1";
          } else {
            this.isEdit = "0";
          }
          this.dataFrom = [];
          // if (!res.data.length) {
          //   this.getInfo();
          //   return;
          // } 
          res.data.map((item) => {
            if (item.isNowUnit == "0") {
              let baseUrl = window.global_config.BASE_URL;
              // 社保证明
              if (item.socialSecurityFile) {
                let url = `${baseUrl}/v1/api/file/${item.socialSecurityFile.id}/view`;
                let a = { url: url, name: item.socialSecurityFile.annexName, id: item.socialSecurityFile.id };
                this.fileList = [];
                this.fileList.push(a);
              }
              if (item.descriptionOfWorkFile) {
                // 工作说明
                let urls = `${baseUrl}/v1/api/file/${item.descriptionOfWorkFile.id}/view`;
                let as = {
                  url: urls,
                  name: item.descriptionOfWorkFile.annexName,
                  id: item.descriptionOfWorkFile.id
                };
                this.fileListWork = [];
                this.fileListWork.push(as);
              }

              this.ruleFormAdd = item;
            } else if (item.isNowUnit == "1") {
              this.dataFrom.push(item);
            }
          });
        }
      });
    },
    submitUpload(file, type) {
      let image = new FormData();
      image.append("file", file.file);
      image.append("type", type);
      getPicture(image).then((res) => {
        if (res.code == "1000") {
          if (type == 2) {
            this.ruleFormAdd.socialSecurityFileId = res.data.id;
          } else {
            this.ruleFormAdd.descriptionOfWorkFileId = res.data.id;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getIndustrys() {
      getDictInfoNew("HYLX").then((res) => {
        this.industryList = res.data;
      });
    },
    handleRemove(file, type) {
      console.log(file)
      let id = ""
      if (file.id) {
        id = file.id
      }
      if (type == 2) {
        if (id == "") {
          id = this.ruleFormAdd.socialSecurityFileId
        }
        delectFile(this.$qs.stringify({ id: id })).then((res) => {
          if (res.code == 1000) {
            this.$message.success("删除成功");
            this.ruleFormAdd.socialSecurityFile = "";
            this.ruleFormAdd.socialSecurityFileId = "";
          }
        });

      } else {
        if (id == "") {
          id = this.ruleFormAdd.descriptionOfWorkFileId
        }
        delectFile(this.$qs.stringify({ id: id })).then((res) => {
          if (res.code == 1000) {
            this.$message.success("删除成功");
            this.ruleFormAdd.socialSecurityFile = "";
            this.ruleFormAdd.descriptionOfWorkFileId = "";
          }
        });

      }
    },
    handlePreview(file) {
      let baseUrl = window.global_config.BASE_URL;
      this.dialogVisible = true;
      this.pdfLook = ""
      this.lookFile = ""
      if (file.id) {
        if (file.name.includes("pdf") || file.name.includes("PDF")) {
          this.pdfLook = `${baseUrl}/v1/api/file/${file.id}/view`;
        } else {
          this.lookFile = `${baseUrl}/v1/api/file/${file.id}/view`;
        }
      } else {
        if (file.name.includes("pdf") || file.name.includes("PDF")) {
          this.pdfLook = URL.createObjectURL(file.raw);
        } else {
          this.lookFile = URL.createObjectURL(file.raw)
        }
      }
      // let id = "13B118A7FB91451DA6A3C2EDAA14128D";
      // window.open(`${baseUrl}/v1/api/file/${file.id}/view`);

    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type == "image/bmp" ||
        file.type === "application/pdf";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (file.type === "application/pdf" && file.size / 1024 / 1024 > 20) {
        this.$message.error("上传附件大小不能超过 20MB!");
        return false;
      }
      if (!isJPG) {
        this.$message.error("上传照片格式只能是jpg、png、jpeg、bmp、pdf。");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }
      if (file.name.length > 50) {
        this.$message.error("文件名称不能超过50位");
        return false;
      }
      return isJPG && isLt2M;
    },
    // beforeRemove(file, fileList) {
    //   return this.$confirm(`确定移除 ${file.name}？`);
    // },
    // saveInfo() {
    //   console.log("保存从业信息");
    // },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    formatTimes(tim) {
      if (!tim) {
        return "";
      } else {
        // tim是整数，否则要parseInt转换
        const time = new Date(tim);
        const y = time.getFullYear();
        const m = time.getMonth() + 1;
        const d = time.getDate();
        return y + "-" + this.add0(m) + "-" + this.add0(d);
      }
    },
    next(ruleFormAdd) {

      if (this.ruleFormAdd.creCode != "") {
        const reg = /^[A-Za-z0-9]{18}$/;
        // const regs = /^[A-Za-z0-9]{15}$/;
        if (!reg.test(this.ruleFormAdd.creCode)) {
          this.$message.warning('统一社会信用代码长度18位数字、字母')
          return false
        }
      }
      if (this.ruleFormAdd.unitName || this.ruleFormAdd.creCode || this.ruleFormAdd.depart || this.ruleFormAdd.post || this.ruleFormAdd.workStartTime || this.ruleFormAdd.workMemo) {
        this.$refs.ruleFormAdd.clearValidate()
        if (!this.ruleFormAdd.unitName || !this.ruleFormAdd.creCode || !this.ruleFormAdd.depart || !this.ruleFormAdd.post || !this.ruleFormAdd.workStartTime) {
          this.$message.warning('请填写所有项')
          return false
        }
        if (this.ruleFormAdd.workEndTime) {
          if (this.ruleFormAdd.workEndTime < this.ruleFormAdd.workStartTime) {
            this.$message.error("工作结束时间不能小于工作开始时间");
            return false;
          }
        }
        let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
        this.ruleFormAdd.isNowUnit = "0";
        this.ruleFormAdd.userId = this.userInfoid;
        let fromINfo = this.ruleFormAdd;
        dataFrom.push(fromINfo);
        this.active = 2;
        this.$parent.next(2, dataFrom, this.isEdit, 2).then(res => {
          if (res) {
            this.getDetail()
          }
        })
      } else {
        this.ruleFormAdd.isNowUnit = "0";
        this.ruleFormAdd.userId = this.userInfoid;
        let fromINfo = this.ruleFormAdd;
        if (this.ruleFormAdd.id && !this.ruleFormAdd.creCode) {
          unitDel(this.$qs.stringify({ id: this.ruleFormAdd.id })).then(res => {
            if (res.code == '1000') {
              let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
              // dataFrom.push(fromINfo);
              this.active = 2;
              this.$parent.next(2, dataFrom, this.isEdit, 2).then(res => {
                if (res) {
                  this.getDetail()
                }
              })
            }
          })
        } else {
          let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
          // dataFrom.push(fromINfo);
          this.active = 2;
          this.$parent.next(2, dataFrom, this.isEdit, 2).then(res => {
            if (res) {
              this.getDetail()
            }
          })
          this.$refs.ruleFormAdd.clearValidate()
        }

      }
    },
    save(ruleFormAdd) {
      if (this.ruleFormAdd.creCode != "") {
        const reg = /^[A-Za-z0-9]{18}$/;
        // const regs = /^[A-Za-z0-9]{15}$/;
        if (!reg.test(this.ruleFormAdd.creCode)) {
          this.$message.warning('统一社会信用代码长度18位数字、字母')
          return false
        }
      }
      if (this.ruleFormAdd.unitName || this.ruleFormAdd.creCode || this.ruleFormAdd.depart || this.ruleFormAdd.post || this.ruleFormAdd.workStartTime || this.ruleFormAdd.workMemo) {
        this.$refs.ruleFormAdd.clearValidate()
        if (!this.ruleFormAdd.unitName || !this.ruleFormAdd.creCode || !this.ruleFormAdd.depart || !this.ruleFormAdd.post || !this.ruleFormAdd.workStartTime) {
          this.$message.warning('请填写所有项')
          return false
        }
        // this.$refs[ruleFormAdd].validate((valid) => {
        //   if (valid) {
        if (this.ruleFormAdd.workEndTime) {
          if (this.ruleFormAdd.workEndTime < this.ruleFormAdd.workStartTime) {
            this.$message.error("工作结束时间不能小于工作开始时间");
            return false;
          }
        }
        let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
        this.ruleFormAdd.isNowUnit = "0";
        this.ruleFormAdd.userId = this.userInfoid;
        let fromINfo = this.ruleFormAdd;
        // if (this.dataFrom.length) {
        dataFrom.push(fromINfo);
        this.active = 2;
        this.$parent.next(2, dataFrom, this.isEdit, 1).then(res => {
          if (res) {
            this.getDetail()
          }
        })
      } else {
        this.ruleFormAdd.isNowUnit = "0";
        this.ruleFormAdd.userId = this.userInfoid;
        let fromINfo = this.ruleFormAdd;
        if (this.ruleFormAdd.id && !this.ruleFormAdd.creCode) {
          unitDel(this.$qs.stringify({ id: this.ruleFormAdd.id })).then(res => {
            if (res.code == '1000') {
              let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
              // dataFrom.push(fromINfo);
              this.active = 2;
              this.$parent.next(2, dataFrom, this.isEdit, 1).then(res => {
                if (res) {
                  this.getDetail()
                }
              })
            }
          })
        } else {
          this.$refs.ruleFormAdd.clearValidate()
          let dataFrom = JSON.parse(JSON.stringify(this.dataFrom));
          // dataFrom.push(fromINfo);
          this.active = 2;
          this.$parent.next(2, dataFrom, this.isEdit, 1).then(res => {
            if (res) {
              this.getDetail()
            }
          })
        }

      }
    },
    prev() {
      let active = 1;
      this.$emit("prev", active);
    },
    addPerson(i, item) {
      this.ruleForm = {};
      this.status = i;

      if (i == 2) {
        let items = JSON.parse(JSON.stringify(item));
        this.dialogFormVisible = true;
        this.ruleForm = items;
      } else {
        this.$nextTick(() => {
          this.$refs["ruleForm"].clearValidate();
          // this.$refs["ruleForm"].resetFields();
        });
        this.dialogFormVisible = true;
      }
    },
    submitForm(formName) {
      // this.id = this.id + 1;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.workEndTime < this.ruleForm.workStartTime) {
            this.$message.error("工作结束时间不能小于工作开始时间");
            return false;
          }
          this.dialogFormVisible = false;
          if (this.status == 2) {
            for (let i = 0; i < this.dataFrom.length; i++) {
              if (this.dataFrom[i].id == this.ruleForm.id) {
                this.dataFrom[i] = this.ruleForm;
              }
            }
          } else {
            // this.ruleForm.id = this.id;
            this.ruleForm.isNowUnit = "1";
            this.ruleForm.userId = this.userInfoid;
            this.dataFrom.push(this.ruleForm);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    del(items, index) {
      this.$confirm("是否确认删除？", {
        type: "error",
      }).then((_) => {
        if (items.id) {
          unitDel(this.$qs.stringify({ id: items.id })).then(res => {
            if (res.code == '1000') {
              this.dataFrom.splice(index, 1);
              this.$message.success('删除成功')
            }
          })
        } else {
          this.dataFrom.splice(index, 1);
          this.$message.success('删除成功')
        }

      })
        .catch((_) => {
          console.log("error");
        });
    },
    nosubmit(formName) {
      // this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    timeout1(val) {
      if (val == null) {
        console.log(1);
      } else {
        this.ruleFormAdd.workStartTime = val[0];
        this.ruleFormAdd.workEndTime = val[1];
      }
    },
    timeout(val) {
      if (val == null) {
        console.log(1);
      } else {
        this.ruleForm.workStartTime = val[0];
        this.ruleForm.workEndTime = val[1];
      }
    },
  },
};
</script>

<style scoped lang="less">
.userInfor {
  margin: 30px 60px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 10px;
  font-size: 15px;
  margin-bottom: 20px;
}

// ::v-deep .el-select-dropdown .el-popper{
//   top: 365px !important;
//   position: absolute;
// }
::v-deep .el-dialog__header {
  text-align: left;
}

::v-deep .el-date-editor.el-input__inner {
  width: 100%;
}

::v-deep .el-select-dropdown {
  position: absolute !important;
  left: 0 !important;
  top: 35px !important;
  text-align: left;
}

::v-deep .el-picker-panel {
  position: absolute !important;
  top: 35px !important;
}

.error {
  ::v-deep .el-form-item__error {
    left: 50% !important;
  }
}

// .el-dialog {
//   ::v-deep .el-date-editor.el-input,
//   .el-date-editor.el-input__inner {
//     width: 100%;
//   }
//   ::v-deep .el-select .el-input__inner {
//     width: 100%;
//     // text-align: left;
//   }
// }
::v-deep.el-select {
  width: 100%;
}

.infomation {
  text-align: left;
  margin: 20px 80px;
  padding: 10px;

  .infomation_item {
    border-bottom: 1px solid #f0f0f0;

    h2 {
      line-height: 30px;
    }

    p {
      display: flex;
      justify-content: flex-start;
      // line-height: 25px;
      margin: 15px 15px 15px 0;

      span {
        background: #f0f0f0;
        padding: 4px 8px;
        margin-right: 10px;
        border-radius: 4px;
      }
    }
  }
}

.timeWorkDialog {
  position: relative;

  // top: 200px;
  .el-picker-panel {
    position: absolute;
    top: 250px;
  }

  ::v-deep .data-style.el-picker-panel {
    ::v-deep .el-popper[x-placement^="bottom"] {
      margin-top: 365px !important;
    }
  }
}

// ::v-deep .el-dialog__header {
//   text-align: left;
//   padding: 18px 20px;
//   border-bottom: 1px solid #ebeef5;
//   box-sizing: border-box;
// }
// ::v-deep .el-dialog__body {
//   padding-left: 0;
//   position: relative;
// }</style>